module.exports = __webpack_public_path__ + "static/img/6-35.a9d4b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutUs/6-35.png
// module id = D3/N
// module chunks = 15